import React from 'react'
import PropTypes from 'prop-types'

class PlanEntryListHeader extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      order: 'DEFAULT'
    }

    this.handleClick = this.handleClick.bind(this)
  }

  componentDidUpdate (prevProps) {
    const orderByHasChanged = prevProps.orderBy !== this.props.orderBy
    const headerIsNotCurrentOrder = this.props.orderBy !== this.props.value
    if (
      orderByHasChanged &&
      headerIsNotCurrentOrder &&
      this.state.order !== 'DEFAULT'
    ) {
      this.setState({ order: 'DEFAULT' })
    }
  }

  handleClick (e) {
    e.preventDefault()
    e.stopPropagation()

    let newOrder
    switch (this.state.order) {
      case 'ASC':
        newOrder = 'DESC'
        break
      case 'DESC':
        newOrder = 'DEFAULT'
        break
      case 'DEFAULT':
        newOrder = 'ASC'
        break
    }

    this.setState({ order: newOrder }, () => {
      this.props.onClick(newOrder)
    })
  }

  getArrowLabel () {
    switch (this.state.order) {
      case 'ASC':
        return <i className='fa fa-angle-down' />
      case 'DESC':
        return <i className='fa fa-angle-up' />
    }
  }

  render () {
    const { label } = this.props

    const arrow = this.getArrowLabel()

    let headerClass = 'PlanEntryListHeader'
    if (this.state.order !== 'DEFAULT') {
      headerClass += ' PlanEntryListHeader--active'
    }

    return (
      <span
        className={`${headerClass} ${
        typeof label === 'string' ? label?.toLowerCase() : ''
          }`}
        onClick={this.handleClick}
      >
        <span>{label}</span>
        {arrow}
      </span>
    )
  }
}

PlanEntryListHeader.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  orderBy: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string
}

export default PlanEntryListHeader
